/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/capital_lvl': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 3c-3.859 0-7 3.14-7 7 0 3.859 3.141 7 7 7s7-3.141 7-7c0-3.86-3.141-7-7-7zm3.354 9.646a.5.5 0 01-.708.708L10 10.707l-2.646 2.646a.5.5 0 11-.708-.706L9.293 10 6.646 7.354a.5.5 0 01.707-.707L10 9.293l2.646-2.646a.5.5 0 01.707.707L10.707 10l2.647 2.646z"/><path pid="1" d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm0 19c-4.963 0-9-4.038-9-9s4.037-9 9-9 9 4.037 9 9c0 4.962-4.037 9-9 9z"/>'
  }
})
